import React, { useEffect, useState } from "react";

export function EditableField({ label, value, canEdit, onCommit }) {
  const [draft, setDraft] = useState(value || "");

  useEffect(() => setDraft(value || ""), [value]);

  if (!canEdit) {
    return (
      <div className="lw-field lw-field--readonly">
        <span>{label}</span>
        <strong>{value || "—"}</strong>
      </div>
    );
  }

  return (
    <label className="lw-field">
      <span>{label}</span>
      <input
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={() => draft !== value && onCommit?.(draft)}
        onKeyDown={(event) => {
          if (event.key === "Enter") event.currentTarget.blur();
          if (event.key === "Escape") {
            setDraft(value || "");
            event.currentTarget.blur();
          }
        }}
      />
    </label>
  );
}
